import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { fontWeightOptions, IAvailableFont, IAvailableFontWithStyles } from '../../../models/configs/fonts.model';
import { ConfigurationAuthApiService } from '../../api/auth/config-auth-api.service';
import { FunctionsHelperService } from '../../functions-helper.service';

@Injectable({
    providedIn: 'root',
})
export class AvailableFontsStoreService {
    private _availableFontsSubject = new BehaviorSubject<IAvailableFontWithStyles[]>(null);
    public availableFonts$ = this._availableFontsSubject.asObservable();

    constructor(
        private configAuthService: ConfigurationAuthApiService,
        private functionsHelper: FunctionsHelperService
    ) {
        this.configAuthService.getAvailableFonts$().subscribe({
            next: (fontsConfigs) => {
                if (!fontsConfigs) {
                    this._availableFontsSubject.error(new Error('Fonts configuration not found'));
                    return;
                }

                const availableFonts = fontsConfigs.sort((a, b) => a.name.localeCompare(b.name));
                const availableFontsWithStyles: IAvailableFontWithStyles[] = [];
                for (const font of availableFonts) {
                    const fontIdWithCapital = font.id;
                    font.id = font.id.toLowerCase();
                    const fontWithStyles: IAvailableFontWithStyles = {
                        ...font,
                        optionalStyles: [],
                    };
                    for (const style of font.availableStyles) {
                        const { weight, whiteThumbSrc, blackThumbSrc } = style;
                        const weightOption = fontWeightOptions.get(weight);
                        if (!weightOption) {
                            continue;
                        }
                        fontWithStyles.optionalStyles.push({
                            id: weight,
                            name: weightOption.name,
                            value: weightOption.value,
                            whiteThumbSrc: whiteThumbSrc,
                            blackThumbSrc: blackThumbSrc,
                            specialFontId: `${fontIdWithCapital}-${weight}`,
                        });
                    }
                    fontWithStyles.optionalStyles.sort((a, b) => a.value - b.value);
                    availableFontsWithStyles.push(fontWithStyles);
                }

                this._availableFontsSubject.next(availableFontsWithStyles);
            },
            error: (error) => {
                this._availableFontsSubject.error(error); // Propagates the error to all subscribers
            },
        });
    }

    getFontsAsync() {
        return this.functionsHelper.getDataAsync(this._availableFontsSubject);
    }
}
